import { Avatar } from '@mui/material';
import React from 'react';
import { extractInitials } from '../../production/header/RoundAvatar';
import { useStyling } from '../Theme';
import { hexToRgba, stringToColor } from '../utils/themeUtils';

export const getInitialsAndStylingForAvatar = (value, theme) => {
    const { getContrastText } = theme.palette;
    const bgCol = stringToColor(value);
    const bgColWithOpacity = hexToRgba(bgCol, 0.7);
    const fgCol = getContrastText(bgCol);
    const sxProps = {
        color: fgCol,
        backgroundColor: bgColWithOpacity,
        width: '30px',
        height: '30px',
        fontSize: '12px',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
    const initials = value ? extractInitials(value).substring(0, 2) : undefined;
    return {
        initials,
        sxProps
    };
};

export default ({ label, avatarSx = {} }) => {
    const { theme } = useStyling();
    const { initials, sxProps } = getInitialsAndStylingForAvatar(label, theme);
    return <Avatar sx={{ ...sxProps, ...avatarSx }}>{initials}</Avatar>;
};
